<template>
    <div class="eva-item">
        <Header title="学生评教"  :casLogin="casLogin"></Header>
        <NOdata v-if="evaluateList.length == 0" title="暂无评教数据~"></NOdata>
        <div class="evaluate_content">
            <div 
                v-for="(item, index) in evaluateList" 
                :key="index" 
                @click="teachEva(item.PJ01ID, item.PJ05ID, item.BATCHID)"
            >
                <div class="xspjItem">
                    <div class="xspjContent">
                        <h4 class="xspjTitle">
                            {{ item.SEMESTER }}
                        </h4>
                        <div class="xspjDesc">
                            <p>评价批次：{{ item.EVALUATIONBATCH }}</p>
                            <p>评价分类：{{ item.PJFLMC }}</p>
                            <p>学期：{{ item.SEMESTER }}</p>
                        </div>
                    </div>
                    <!-- <span class="icon_right"></span> -->
                    <div class="xspjLine"></div>
                    <div class="xspjBtn"><button>进入评价</button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../utils/axios';
export default {
    data() {
        return {
            casLogin: sessionStorage.getItem('casLogin'),
            evaluateList: [],
            schoolCode: sessionStorage.getItem('schoolCode')
        };
    },
    created() {
        this.getEvaluate();
    },
    methods: {
        async getEvaluate() {
            const res = await Api.getEvaluateApi();
            this.evaluateList = res.data;
        },
        teachEva(id1, id2, id3) {
            let p = '/student/teachEvaluate_10013';
            
            this.$router.push({
                path: p,
                query: {
                    pj01id: id1,
                    pj05id: id2,
                    pj0502id: id3
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.eva-item .evaluate_content {
    font-family: PingFangSC;
    padding: 20px;
    .xspjItem{
        position: relative;
        height: 162px;
        background-image: linear-gradient(180deg,#edf5ff 0%,#f9fbff 100%);
        padding: 0px 0 0 19.5px;
        margin-bottom: 12px;
        .xspjContent{        
            .xspjTitle{
                padding: 15px 0;
                font-size: 16px;
                font-weight: 500;
                color: #333;
            }
            .xspjDesc{
                font-size: 14px;
                font-weight: 400;
                color: #9ea8bb;
                padding-bottom: 12px;
            }
        }
        .xspjLine{
            // width: 344px;
            // height: 1px;
            border: 0.1px dashed #9ea8bb;
            // border-style: dashed;
            opacity: 0.3;
            // height: ;
            
        }
        .xspjBtn{
            // display: block;
            // position: relative;
            position: absolute;
            right: 15px;
            bottom: 1px;
            background-color: #3e7cf8;
            color: white;
            width: 88px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 17px;
            // margin-top: 8px;
        }
    }
    
}
// .eva-item .evaluate_content > div {
//     width: 100%;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     background: @attendance-background-color-10;
//     padding: 10px 20px;
//     box-sizing: border-box;
//     color: @attendance-color-2;
//     margin-bottom: 15px;
//     border-radius: 5px;
//     position: relative;
// }
// .eva-item .evaluate_content > div::after {
//     position: absolute;
//     content: '';
//     background-color: @attendance-background-color-1;
//     width: 3px;
//     left: 0;
//     border-radius: 5px 0 0 5px;
//     height: 100%;
// }
// .eva-item .evaluate_content > div p {
//     color: @attendance-color-2;
//     font-size: 12px;
//     line-height: 17px;
//     margin-bottom: 2px;
// }
// .eva-item .evaluate_content > div h4 {
//     color: @attendance-color-1;
//     font-size: 16px;
//     line-height: 22px;
//     margin-bottom: 4px;
// }
.eva-item .evaluate_content div .icon_right {
    height: 15px;
    width: 15px;
    background: url(../../../../static/img/arrow.png) center center no-repeat;
    background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/evaluate_10013.vue